
import React, { useEffect, useRef, useState } from "react";
import './Header.css';
import posLogoIcon from '../assets/posLogo.png'
import posLogoName from '../assets/posLogoName.png'
import MenuIcon from '../assets/menuIcon.png'

const Header = () => {

    const [mobileView, setMobileView]: any = useState<boolean>(
        window.innerWidth <= 768
    );

    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        function updateSize() {
            if (window.innerWidth <= 768)
                setMobileView(true);
            else
                setMobileView(false);
        }
        window.addEventListener("resize", updateSize);
    }, [mobileView]);

    function scrollWithId(idName: any) {
        const element = document.getElementById(idName);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        } else {
            console.error('Element with id ' + idName + ' not found.');
        }
    }


    return (
        <div className="haederMainContainer">
            <div className="logoDiv">
                <img src={posLogoIcon} alt="" className="posLogoIcon" />
                <img src={posLogoName} alt="" style={{ width: mobileView ? '135px' : '15vw' }} />
            </div>
            {!mobileView ? <>
                <div className="menuMainDiv">
                    <h3 style={{ minWidth: '6.25vw', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0.75vw 1.125vw', fontWeight: 600, cursor: 'pointer', color: '#39C4FF', letterSpacing: '1.8px' }} onClick={() => { scrollWithId("firstBanner") }}>
                        Home
                    </h3>
                    <h3 style={{ minWidth: '6.25vw', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0.75vw 1.125vw', fontWeight: 600, cursor: 'pointer', color: '#39C4FF', letterSpacing: '1.8px' }} onClick={() => { scrollWithId("services") }}>
                        Services
                    </h3>
                    <h3 style={{ minWidth: '6.25vw', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0.75vw 1.125vw', fontWeight: 600, cursor: 'pointer', color: '#39C4FF', letterSpacing: '1.8px' }} onClick={() => { scrollWithId("posSystem") }}>
                        POS System
                    </h3>
                    <h3 style={{ minWidth: '6.25vw', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0.75vw 1.125vw', fontWeight: 600, cursor: 'pointer', color: '#39C4FF', letterSpacing: '1.8px' }} onClick={() => { scrollWithId("downLoad") }}>
                        Download
                    </h3>
                </div>
                <div className='downloadAppDiv'>
                    <h4 style={{ backgroundColor: 'black', color: '#fff', padding: '0.75vw 1.125vw', fontWeight: 500, borderRadius: 6, cursor: 'pointer' }}>
                        Download App
                    </h4>
                </div>
            </>
                :
                <div className="mobile-menu">
                    {/* <FaBars className="menu-icon" onClick={toggleMenu} /> */}
                    <img src={MenuIcon} style={{width:30,height:30}} alt="" onClick={toggleMenu} />
                    {isOpen && (
                        <div className="menu-list">
                            <ul>
                                <li onClick={() => { scrollWithId("firstBanner");setIsOpen(false) }}>Home</li>
                                <li onClick={() => { scrollWithId("services");setIsOpen(false) }}>Services</li>
                                <li onClick={() => { scrollWithId("posSystem");setIsOpen(false) }}>POS System</li>
                                <li onClick={() => { scrollWithId("downLoad");setIsOpen(false) }}>Download</li>
                            </ul>
                        </div>
                    )}
                </div>
            }
            <div>

            </div>
        </div>
    );
};

export default Header;
